"use client";

import { PageMetaData, StickySearchBar } from '@/components';
import { TopBar, TopNavBar, Footer } from '@/layout';
import { useBookPage } from '@/hooks/useBookPage';
import { useBookPageSectionFlags } from '@/hooks/useBookPageSectionFlags';
import { Col, Container, Row } from 'react-bootstrap';
import Hero from './components/Hero';
import TourCardList from './components/TourCardList';
import ExcursionsSearchPanel from './components/ExcursionsSearchPanel';

const isBookSectionInactive = (flags) => {
  if (!flags) return false;
  return flags.is_active !== 1 && flags.is_active !== true && flags.is_active !== '1';
};

const Tours = ({
  header = null,
  footer = null,
  noIndex = false,
  canonicalUrl = null,
  excursionBasePath = '/excursions',
}) => {
  const { section: excursionsIntroSection, loading: excursionsIntroLoading } =
    useBookPage('excursions_intro');
  const { flags: excursionsIntroFlags, loading: excursionsIntroFlagsLoading } =
    useBookPageSectionFlags('excursions_intro');

  const showExcursionsSearchAboveList =
    !excursionsIntroLoading &&
    !excursionsIntroFlagsLoading &&
    excursionsIntroSection == null &&
    isBookSectionInactive(excursionsIntroFlags) &&
    excursionsIntroFlags?.show_search_form !== false;
  const showListSeoIntro =
    !excursionsIntroLoading &&
    !excursionsIntroFlagsLoading &&
    excursionsIntroSection == null &&
    isBookSectionInactive(excursionsIntroFlags);
  const listTitle = excursionsIntroFlags?.title?.trim() || 'Selected Excursions in East Crete';
  const listIntro =
    excursionsIntroFlags?.intro_text?.trim() ||
    'Discover handpicked tours and experiences across East Crete, curated for different travel styles, interests, and expectations.';

  const headerNode = header ?? (
    <>
      <TopBar />
      <TopNavBar />
    </>
  );
  const footerNode = footer ?? <Footer />;

  return (
    <>
      {noIndex || canonicalUrl ? (
        <PageMetaData
          title="Tours & Excursions"
          description="Explore Crete with our curated tours and unforgettable excursions. Discover hidden gems and iconic destinations."
          keywords="tours Crete, excursions Crete, Crete tours booking"
          noIndex={noIndex}
          canonicalOverride={canonicalUrl}
          url="/excursions"
        />
      ) : null}
      {headerNode}
      {String(excursionBasePath || '').startsWith('/partner/') ? <StickySearchBar /> : null}
      
      <main>
        <Hero excursionBasePath={excursionBasePath} />
        {showListSeoIntro ? (
          <section className="excursions-seo-intro-section bg-white pt-4 pt-lg-5 pb-0">
            <Container>
              <Row className="mb-4">
                <Col>
                  <h1 className="sec-title mb-3">{listTitle}</h1>
                  <p className="text-muted mb-0" dangerouslySetInnerHTML={{ __html: listIntro }} />
                </Col>
              </Row>
            </Container>
          </section>
        ) : null}
        {showExcursionsSearchAboveList ? (
          <div className="mb-4">
            <ExcursionsSearchPanel
              variant="aboveResults"
              searchOnly
              showSearchForm
              bandSurface={
                excursionsIntroFlags?.show_section_background_when_inactive
                  ? {
                      backgroundColor: excursionsIntroFlags.background_color,
                      backgroundEffect: excursionsIntroFlags.background_effect,
                    }
                  : null
              }
            />
          </div>
        ) : null}
        <TourCardList excursionBasePath={excursionBasePath} />
      </main>
      
      {footerNode}
    </>
  );
};

export default Tours;
